import { type WithChildren } from '@dynatrace/strato-components/core';

import { useGridPlotSize } from '../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { TimeseriesChartYScalesContext } from '../context/TimeseriesChartYScales.context.js';
import { useTimeseriesFilteredData } from '../hooks/useTimeseriesFilteredData.js';
import { useTimeseriesFilteredYAxis } from '../hooks/useTimeseriesFilteredYAxis.js';
import { buildYScales } from '../utils/yAxis.js';

export const TimeseriesChartYScalesProvider = ({ children }: WithChildren) => {
  const { dataPerVariant, seriesMap, datapointsMap } =
    useTimeseriesFilteredData();
  const yAxis = useTimeseriesFilteredYAxis();
  const { height } = useGridPlotSize();

  const yScales = buildYScales(
    dataPerVariant,
    yAxis,
    height,
    seriesMap,
    datapointsMap,
  );

  return (
    <TimeseriesChartYScalesContext.Provider value={yScales}>
      {children}
    </TimeseriesChartYScalesContext.Provider>
  );
};

TimeseriesChartYScalesProvider['displayName'] =
  'TimeseriesChartYScalesProvider';
